import React from 'react';
import './Technology.css';
import technologyImage from '../assets/images/latent-energy-process-2.png';

const Technology = () => {

  const steps = [
    {
      number: '01',
      title: 'Novel concept and engineering',
      description: 'By co-recycling of two streams, we utilize the waste itself as the source of energy and resources required to upgrade the products',
    },
    {
      number: '02',
      title: 'Holistic and sort-free solution',
      description: 'Enables the recycling of all plastic types, including complex packaging, composite and mixed materials, and unsorted plastic waste.',
    },
    {
      number: '03',
      title: 'Circularity',
      description: 'High-quality output, aluminium oxide and light naphtha (refinery grade), serving as feedstocks for aluminum and virgin-plastics production, closing the plastic loop',
    },
    {
      number: '04',
      title: 'Profitability',
      description: 'Low-cost and widely available feedstock recycled to in demand products enables profitability above industry norms, even before incentives or regulation, positioning the technology for wide adoption.',
    },
  ];

  return (
    <section id="technology" className="technology">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Technology</h2>
          <p className="section-subtitle">Paradigm-Shifting Process – Co-recycles two waste streams, balancing its required energy and resources</p>
        </div>

        <div className="tech-intro">
          <p>Our technology enables the recycling of all plastic types, including the core unrecyclable fraction, addressing a critical market failure. We harness the <strong>latent energy</strong> stored within the waste itself to power the entire process — creating a self-sustaining, zero-emission system.</p>
          <div className="tech-image-container">
            <img src={technologyImage} alt="Technology Process" className="tech-image" />
          </div>
        </div>

        <div className="technology-grid">
          {steps.map((step, index) => (
            <div
              key={index}
              className="tech-card"
            >
              <div className="tech-number">
                {step.number}
              </div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>

              {index < steps.length - 1 && (
                <div className="tech-arrow">
                  →
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;
